// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { MapViewer } from '../../../types/VisioglobeType';
import { isOutdatedNavigator } from '../../../utils/utils';

type Props = {
  mapviewer: MapViewer,
  overlay: React.Node,
}

type State = {
  outdatedNavigator: boolean,
}

class BaseMap extends React.Component<Props, State> {
  state: State = {
    outdatedNavigator: isOutdatedNavigator(),
  };

  render() {
    return (
      <div className="gemini-container">
        {
          this.state.outdatedNavigator &&
          <div id="outdated">
            <p>
              <Translate value="navigator.outdated" />
            </p>
            <button onClick={() => this.setState({ outdatedNavigator: false })}>x</button>
          </div>
        }
        <div className="gemini-map-container">
          {this.props.overlay}
        </div>
      </div>
    );
  }
}

export default (BaseMap);
